export default "__VITE_ASSET__6f2bbf60__"